<template>
    <el-menu background-color="#545c64" text-color="#fff" active-text-color="#ffd04b"
        :default-active="actId"
        :collapse="isCollapse"
        :collapse-transition="false"
        @select="selectMenu" router>
        <el-sub-menu :index="(''+menu.fMenu.id)" v-for="menu in menuData" :key="menu.fMenu.id">
            <template #title>
                <el-icon><component :is="getMenuIcon(menu.fMenu.css)" /></el-icon>
                <span>{{menu.fMenu.name}}</span>
            </template>
            <el-menu-item v-for="smenu in menu.sMenuList" :key="smenu.id" style="padding-left: 50px" :index="(''+smenu.id)" :route="smenu.linkurl">{{smenu.name}}</el-menu-item>
        </el-sub-menu>
    </el-menu>
</template>

<script>
export default {
    props: {
        actId: {
            type: String,
            default(){
                return "0"
            }
        },
        menuData: {
            type: Array,
            default() {
                return [];
            },
        },
        isCollapse: {
            type: Boolean,
            default() {
                return false
            }
        }
    },
    methods: {
        selectMenu(key, keyPath) {
            this.$emit("selectMenu", { sMenuIndex: key, fMenuIndex: keyPath[0], menu: 1});
        },
        getMenuIcon(css) {
            if (!css) return 'Operation';
            const map = {
                'el-icon-s-operation': 'Operation',
                'el-icon-user': 'User',
                'el-icon-s-order': 'List',
                'el-icon-s-marketing': 'Promotion',
                'el-icon-s-data': 'DataAnalysis',
                'el-icon-s-tools': 'Setting',
                'el-icon-s-home': 'HomeFilled',
                'el-icon-s-shop': 'Shop',
                'el-icon-s-comment': 'ChatDotSquare',
                'el-icon-s-platform': 'Monitor',
                'el-icon-s-custom': 'Service',
                'el-icon-s-flag': 'Flag',
                'el-icon-s-grid': 'Grid',
                'el-icon-s-release': 'Promotion',
                'el-icon-s-open': 'Open',
                'el-icon-s-management': 'Management',
                'el-icon-s-check': 'Check',
                'el-icon-s-truck': 'Truck',
            };
            if (map[css]) return map[css];
            // 自动转换：el-icon-xxx / el-icon-s-xxx → PascalCase
            return css.replace(/^el-icon-(s-)?/, '').replace(/(?:^|-)(\w)/g, (_, c) => c.toUpperCase());
        },
    },
};
</script>